import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { tap } from 'rxjs';
import { inject } from '@angular/core';
import { TimeoutService } from '../service/timeout.service';

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const timeOutService = inject(TimeoutService);

  if (environment.env === 'QA') {
    req = req.clone({
      setHeaders: {
        env: 'QA',
      },
    });
  }

  return next(req).pipe(
    tap(() => {
      timeOutService.iniciarTimeOut();
    }),
  );
};
